import { createContext } from 'react';

export const StaffIdContext = createContext({});
